import { useState, useContext } from "react";
import { RiCloseFill } from "react-icons/ri"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from "src/provider/API/call-service";
import { AbsoluteContainer, AppText, Button, FlexColumn, FlexRow, Form, FormGroup, SidePopupContainer } from "src/style"
import { useTranslation } from "react-i18next";


export const AddNewSlide: React.FC<any> = ({getSlides, close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({title: '', body: ''})
    const {t} = useTranslation()

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
        const charLength = e.target.name === 'title' ? 25 : 100
        if (e.target.value.length <= charLength) setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const response = await API.addNewOnboardingSlide(input)
        if (response) {
            if (getSlides) await getSlides()
        }    
        close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="new-ads-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <AbsoluteContainer top='1.5' right='1.5'>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </AbsoluteContainer>
                <AppText color='#101828' textSize="1.8" fontWeight="700" fontFamily="Gilmer-Bold">
                   {t('onboardingSlides.newSlidePopup.title')}
                </AppText>
                <Form onSubmit={handleSubmit}>
                    <FormGroup topMargin='2'>
                        <label>{t('onboardingSlides.newSlidePopup.sliderTitle')}</label>
                        <input 
                            placeholder={t('onboardingSlides.newSlidePopup.sliderTitlePlaceholder')}
                            name='title'
                            value={input.title}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>{t('onboardingSlides.newSlidePopup.sliderBody')}</label>
                        <textarea 
                            placeholder= {t('onboardingSlides.newSlidePopup.slideBodyPlaceholder')}
                            name='body'
                            value={input.body}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                    
                    <FlexRow justifyContent='flex-end' topMargin='2'>
                        <Button
                            width='10.9'
                            titleSize='1.4' fontWeight='600'
                            height='5' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            {t('onboardingSlides.newSlidePopup.saveButton')}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}